export default __webpack_public_path__ + "static/media/carousel.e6172ec8.less";